// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__9+8lx","description":"MealItem_description__iY065","price":"MealItem_price__KVQ-x"};